module.exports = __webpack_public_path__ + "img/habanero.a994da53.svg";